import { gql } from '@apollo/client';
import client from '../../graphql/client';
import { applicationBasicFragment, ratingsByEmployerFragment } from '../application/queries';

/* all applications fetch */
const fetchAllApplicationsGraphql = (payload) => {
  const params = {};
  const { variables } = payload;

  if (payload.recache) {
    params.fetchPolicy = 'network-only';
  }

  const query = gql`
    query allApplications(
      $candidateName: String
      $tags: [Int]
      $projects: [Int]
      $offset: Int
      $limit: Int
    ) {
      allApplicationsInProjects(
        candidateName: $candidateName
        tags: $tags
        projects: $projects
        offset: $offset
        limit: $limit
      ) {
        count
        projectSelectionLevels {
          projectId
          selectionLevels {
            level
            name
            hidden
            order
            sentiment
          }
        }
        applications {
          id
          ...BasicFields
          ...RatingsByEmployerFields
          fromSite
          projects {
            id
            name
          }
          job {
            id
            title
          }
          tags {
            id
            name
            special_type
          }
          relevance
          processingStatus
          feedback
          summary
        }
      }
    }
    ${applicationBasicFragment}
    ${ratingsByEmployerFragment}
  `;

  return client.query({
    query,
    variables,
    ...params,
  });
};

const fetchAllTagsGraphql = () => {
  const query = gql`
    query tagFilters {
      projectFilters {
        id
        name
      }
    }
  `;

  return client.query({
    query,
  });
};

const fetchProjectsGraphql = () => {
  const query = gql`
    query projectsFilterList {
      projects(sortField: "", sortDirection: "desc", limit: null) {
        project {
          id
          name
        }
      }
    }
  `;

  return client.query({
    query,
  });
};

export { fetchAllApplicationsGraphql, fetchAllTagsGraphql, fetchProjectsGraphql };
